function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.currentTarget.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
  }

  connectedCallback() {
    // On initial (streaming) load the <menu-drawer> is upgraded at its start
    // tag, so its <details>/<summary> children are not parsed yet and
    // querySelector('details') returns null. Defer binding until the DOM is
    // ready in that case. For AJAX re-renders (innerHTML) the subtree is
    // already complete, so we bind immediately.
    this.mainDetailsToggle = this.querySelector('details');
    if (this.mainDetailsToggle) {
      this.bindEvents();
    } else if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.mainDetailsToggle = this.querySelector('details');
        this.bindEvents();
      }, { once: true });
    }
  }

  bindEvents() {
    // Called on initial load and again after every AJAX re-render
    // (facets.js). On a re-render the inner .js-filter <summary>/<button>
    // nodes are destroyed and recreated via innerHTML, so they need fresh
    // handlers. Guard PER ELEMENT (not with one drawer-level flag) so that:
    //   - newly-created summaries get bound, and
    //   - elements that already persist are never bound twice.
    this.querySelectorAll('summary').forEach(summary => {
      if (summary.__menuDrawerBound) return;
      summary.addEventListener('click', this.onSummaryClick.bind(this));
      summary.__menuDrawerBound = true;
    });
    this.querySelectorAll('button').forEach(button => {
      if (button.__menuDrawerBound) return;
      button.addEventListener('click', this.onCloseButtonClick.bind(this));
      button.__menuDrawerBound = true;
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateSelectedSwatchValue(event);
      this.update_sticky_btn();
      this.update_notify();
      this.updateQuan();
      this.updateURL();
      this.updateVariantInput();
      this.updateVariantInputss();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    // Variant in Product Card
    if (this.dataset.layout == 'card') { 
      const card = this.closest('.card');
      const newMedia = card.querySelector(
        `[data-media-id="${this.dataset.section}-${this.dataset.product}-${this.currentVariant.featured_media.id}"]`
      );  
      if (!newMedia) return;
      const modalContent = card.querySelector('.card__media');
      //const modalContent = document.querySelector(`#webipro-${this.dataset.section}-${this.dataset.block}-${this.dataset.product}`);
      const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
      const parent = newMedia.parentElement;
      if (parent.firstChild == newMedia) return;
      parent.prepend(newMedia);
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (this.stickyHeader) {
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }
    } else {
      // PDP: switch gallery to variant's featured image
      var sectionId = this.dataset.section;
      var mediaId = sectionId + '-' + this.currentVariant.featured_media.id;

      var galleryEl = document.querySelector('.gallery-main-left, .gallery-main-right, .gallery-main-center, .gallery-noslider');
      if (galleryEl && galleryEl.swiper) {
        var slides = galleryEl.querySelectorAll('.swiper-slide');
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') === mediaId) {
            galleryEl.swiper.slideTo(i);
            break;
          }
        }
      }
    } 

  }

    updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;
    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const selectedSwatchValue = this.querySelector(`[data-opt="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-opt="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }
  
  
  update_sticky_btn(){
    var sticky_btn_txt = this.currentVariant.available;
    if(sticky_btn_txt == true){
      $('button.sticky-btn').text('Add to cart');
      $('button.sticky-btn').removeAttr('disabled');
    }else{
      $('button.sticky-btn').text('Soldout');
      $('button.sticky-btn').attr('disabled', 'disabled');;
    }
  }
  
  update_notify(){
    if(this.currentVariant.available != true){
       $('.notify-sold').show();
        $('.product').find('.product-form__buttons').hide();
      }else{
       $('.notify-sold').hide();
        $('.product').find('.product-form__buttons').show();
    }

    $('#notify-me').find('.variant-title').text(this.currentVariant.title); 
    var prod_title = $('#notify-me-wrapper').find('#hidden_var').attr('data-product');
    $('#notify-me-wrapper').find('#hidden_var').val(prod_title + ' - '+ this.currentVariant.title); 
  }
  
    updateQuan() {
    var value = this.currentVariant.id;
    var $input = $('#inventory[value="'+value+'"]');
    var inventory = $input.attr('data-inventory');
    var inventory_policy = $input.attr('data-inventory-policy');
    var whNorth = $input.attr('data-warehouse-a');
    var whSouth = $input.attr('data-warehouse-b');
    var whNorthNum = parseInt(whNorth, 10);
    var whSouthNum = parseInt(whSouth, 10);
    var hasWarehouseData = !isNaN(whNorthNum) && whNorthNum >= 0 && !isNaN(whSouthNum) && whSouthNum >= 0;
    // Store warehouse stock data for cart page checkout interception
    if (hasWarehouseData && value) {
      try {
        var whData = { n: whNorthNum, s: whSouthNum, vid: value };
        localStorage.setItem('wh_stock_' + value, JSON.stringify(whData));
      } catch(e) {}
    }

    // Clear all inventory displays
    $(".price-wrp .available-product").remove();
    $(".price-wrp .warehouse-inventory").remove();

    if (this.currentVariant.inventory_management !== 'shopify') return;

    // If warehouse metafield data is available, show per-warehouse cards
    if (hasWarehouseData) {
      var vs = window.variantStrings;
      var expectedBackA = $input.attr('data-expected-back-a') || '';
      var expectedBackB = $input.attr('data-expected-back-b') || '';
      var whHtml = '<div class="warehouse-inventory">';
      whHtml += '<div class="wh-cards">';
      whHtml += this._buildWarehouseCard(
        vs.warehouseAName || 'Auckland',
        whNorthNum,
        vs.warehouseALeadTime || '1-2 business days',
        vs,
        whSouthNum,
        expectedBackA
      );
      whHtml += this._buildWarehouseCard(
        vs.warehouseBName || 'Christchurch',
        whSouthNum,
        vs.warehouseBLeadTime || '2-4 business days',
        vs,
        whNorthNum,
        expectedBackB
      );
      whHtml += '</div>';
      if (whNorthNum <= 0 && whSouthNum <= 0) {
        whHtml += '<div class="wh-info-banner">' +
          '<span class="wh-info-banner__icon">' +
            '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="9" stroke="#5b9bd5" stroke-width="1.5"/><path d="M9.5 5.5h1v1h-1zM9.5 8.5h1v6h-1z" fill="#5b9bd5"/></svg>' +
          '</span>' +
          '<span class="wh-info-banner__text">You can still place your order today. We\'ll dispatch or arrange pickup once new stock arrives.</span>' +
        '</div>';
      }
      whHtml += '</div>';
      $(".price-wrp").append(whHtml);
      return;
    }

    // Fallback: aggregate inventory display (no metafield data)
    if (inventory > 0) {
      if (inventory <= 10) {
        $(".price-wrp").append(
          '<div class="available-product"><b>Low stock:</b> Left ' + inventory + '</div>'
        );
      } else {
        $(".price-wrp").append('<div class="available-product">Available</div>');
      }
    } else {
      if (inventory_policy === 'continue') {
        $(".price-wrp").append('<div class="available-product">Product is in stock</div>');
      } else {
        $(".price-wrp").append('<div class="available-product soldout">Product is out of stock</div>');
      }
    }
  }

  _buildWarehouseCard(name, stock, leadTime, vs, otherStock, expectedBack) {
    var cardClass = 'wh-card';
    var badgeClass = 'wh-status-badge';
    var statusLabel;
    var iconSvg = '';
    var subtitleHtml = '';
    var bodyHtml = '';

    if (stock > 10) {
      cardClass += ' wh-instock';
      badgeClass += ' badge-instock';
      statusLabel = vs.warehouseInStockLabel || 'in stock';
      iconSvg = '<svg width="28" height="28" viewBox="0 0 28 28" fill="none"><circle cx="14" cy="14" r="12" stroke="#328C50" stroke-width="2"/><path d="M8 14l3.5 3.5L20 10.5" stroke="#328C50" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      subtitleHtml = '<div class="wh-availability">Pick up available</div>';
      bodyHtml = '<div class="wh-delivery">' +
        '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><rect x="0.5" y="2.5" width="9" height="8" rx="1" stroke="currentColor" stroke-width="1"/><path d="M10 5.5h2.5l1.5 1.5v3H10v-4.5z" stroke="currentColor" stroke-width="1"/><circle cx="3.5" cy="12" r="1.5" stroke="currentColor" stroke-width="1"/><circle cx="10.5" cy="12" r="1.5" stroke="currentColor" stroke-width="1"/></svg>' +
        '<span>' + leadTime + '</span></div>';
    } else if (stock > 0) {
      cardClass += ' wh-lowstock';
      badgeClass += ' badge-lowstock';
      statusLabel = vs.warehouseLowStockLabel || 'low stock';
      iconSvg = '<svg width="28" height="28" viewBox="0 0 28 28" fill="none"><circle cx="14" cy="14" r="12" stroke="#e8960c" stroke-width="2"/><path d="M14 8v7" stroke="#e8960c" stroke-width="2" stroke-linecap="round"/><circle cx="14" cy="19.5" r="1" fill="#e8960c"/></svg>';
      subtitleHtml = '<div class="wh-availability">Pick up available</div>';
      bodyHtml = '<div class="wh-delivery">' +
        '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><rect x="0.5" y="2.5" width="9" height="8" rx="1" stroke="currentColor" stroke-width="1"/><path d="M10 5.5h2.5l1.5 1.5v3H10v-4.5z" stroke="currentColor" stroke-width="1"/><circle cx="3.5" cy="12" r="1.5" stroke="currentColor" stroke-width="1"/><circle cx="10.5" cy="12" r="1.5" stroke="currentColor" stroke-width="1"/></svg>' +
        '<span>' + leadTime + '</span></div>';
    } else if (otherStock > 0) {
      cardClass += ' wh-pickup-unavailable';
      badgeClass += ' badge-pickup-unavailable';
      statusLabel = vs.warehousePickupUnavailableLabel || 'Pickup Unavailable';
      iconSvg = '<svg width="28" height="28" viewBox="0 0 28 28" fill="none"><circle cx="14" cy="14" r="12" stroke="#888" stroke-width="2"/><path d="M14 8v7" stroke="#888" stroke-width="2" stroke-linecap="round"/><circle cx="14" cy="19.5" r="1" fill="#888"/></svg>';
      subtitleHtml = '<div class="wh-availability">Delivery available</div>';
      bodyHtml = '<div class="wh-delivery">' +
        '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><rect x="0.5" y="2.5" width="9" height="8" rx="1" stroke="currentColor" stroke-width="1"/><path d="M10 5.5h2.5l1.5 1.5v3H10v-4.5z" stroke="currentColor" stroke-width="1"/><circle cx="3.5" cy="12" r="1.5" stroke="currentColor" stroke-width="1"/><circle cx="10.5" cy="12" r="1.5" stroke="currentColor" stroke-width="1"/></svg>' +
        '<span>' + leadTime + '</span></div>';
    } else {
      // Both OOS: one-row layout (icon left, name center, badge right) + second row with date or notify button
      cardClass += ' wh-outofstock wh-oos-both';
      badgeClass += ' badge-outofstock';
      statusLabel = vs.warehouseOutOfStockLabel || 'out of stock';
      iconSvg = '<svg width="28" height="28" viewBox="0 0 28 28" fill="none"><circle cx="14" cy="14" r="12" stroke="#cc3333" stroke-width="2"/><path d="M9.5 9.5l9 9M18.5 9.5l-9 9" stroke="#cc3333" stroke-width="2" stroke-linecap="round"/></svg>';
      if (expectedBack) {
        bodyHtml = '<div class="wh-expected-back">' +
          '<span class="wh-expected-back-label">Expected back in stock:</span> ' +
          '<span class="wh-expected-back-date">' + expectedBack + '</span></div>';
      } else {
        bodyHtml = '<button type="button" class="wh-notify-btn js-notify-btn" data-variant-id="' + (this.currentVariant ? this.currentVariant.id : '') + '" onclick="window.openNotifyModal(' + (this.currentVariant ? this.currentVariant.id : '') + ')">Notify Me When Available</button>';
      }
    }

    // Both OOS uses a flat one-row header layout
    if (stock <= 0 && otherStock <= 0) {
      return '<div class="' + cardClass + '">' +
        '<div class="wh-card-row">' +
          '<span class="wh-icon">' + iconSvg + '</span>' +
          '<span class="wh-location-name">' + name + '</span>' +
          '<span class="' + badgeClass + '">' + statusLabel + '</span>' +
        '</div>' +
        bodyHtml +
      '</div>';
    }

    return '<div class="' + cardClass + '">' +
      '<div class="wh-card-header">' +
        '<span class="wh-icon">' + iconSvg + '</span>' +
        '<div class="wh-card-info">' +
          '<div class="wh-card-top">' +
            '<span class="wh-location-name">' + name + '</span>' +
            '<span class="' + badgeClass + '">' + statusLabel + '</span>' +
          '</div>' +
          subtitleHtml +
          bodyHtml +
        '</div>' +
      '</div>' +
    '</div>';
  }
  
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateVariantInputss() {
        if (this.dataset.layout == 'product-page-first-section') {
      const product = this.closest('.product-page-first-section');
      const mainproductForms = product.querySelectorAll(`#mainProductInfo-${this.dataset.section}-${this.dataset.product}`);
      mainproductForms.forEach((mainproductForm) => {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        fieldsets.forEach(function(option) {
          Array.from(option.querySelectorAll('label')).find((element) => element.classList.remove('active'));
        });
        
        this.options.forEach(function(option) {
            mainproductForm.querySelector(`[data-val="${option}"]`).classList.add('active');
        });
      });
      return;
    }
  }
  
  updateVariantInput() {
    //  Variant in Product Card
    if (this.dataset.layout == 'card') {
      const card = this.closest('.card');
      const productForms = card.querySelectorAll(`#ProductInfo-${this.dataset.section}-${this.dataset.product}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        fieldsets.forEach(function(option) {
          Array.from(option.querySelectorAll('label')).find((element) => element.classList.remove('active'));
        });
        
        this.options.forEach(function(option) {
            productForm.querySelector(`[data-val="${option}"]`).classList.add('active');
        });
        // const productData = this.getVariantData();
        // const selectVariant = productData.find(e => e.id === this.currentVariant.id);
        // if (selectVariant) {
        //   const priceEl = card.querySelector('.price'); 
        //   priceEl.querySelector('.price-item.price-item--regular').innerHTML = selectVariant.price;
        //   priceEl.querySelector('.price-item.price-item--sale').innerHTML = selectVariant.price;
        //   if (selectVariant.compare_at_price != null) {
        //     priceEl.classList.add('price--on-sale');
        //     priceEl.querySelector('.price__sale').querySelector('.price-item.price-item--regular').innerHTML = selectVariant.compare_at_price;
        //   } else {
        //     priceEl.classList.remove('price--on-sale'); 
        //   }
        // }

        const optionData = this.closest('.grid__item').querySelectorAll('select option');
        const regularPrice = this.closest('.grid__item').querySelector('.price .price-item--regular');
        const saleRegularPrice = this.closest('.grid__item').querySelector('.price .price-item--regular');
        const salePrice = this.closest('.grid__item').querySelector('.price .price-item--sale');
        optionData.forEach((data) => {
            if(data.value == this.currentVariant.id) {
                if(data.dataset.cprice != '') {
                    saleRegularPrice.innerHTML = data.dataset.price; 
                    salePrice.innerHTML = data.dataset.cprice;
                    this.closest('.grid__item').querySelector('.price').classList.add("price--on-sale");
                }
                else {
                    regularPrice.innerHTML = data.dataset.price;
                    this.closest('.grid__item').querySelector('.price').classList.remove("price--on-sale");
                }
            }
        });
      });
      return;
    }
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    //  Variant in Product Card
    if (this.dataset.layout == 'card') {
      this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut); 
      return;
    }

    // sticky-cart
    $('.selectedOpt').html(this.currentVariant.title);
    $('.stickCtImg').attr('src', this.currentVariant.featured_image.src+'&width=100');
    var mf_formate =  $('.sticky-price .price-item--regular').attr('shop-format');
     $('.sticky-price .price-item--regular').text(Shopify.formatMoney(this.currentVariant.price, mf_formate));

    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    //  Variant in Product Card
    var selector = `product-form-${this.dataset.section}`;
    if (this.dataset.layout == 'card') {
      selector = `product-form-${this.dataset.section}-${this.dataset.product}`;
    }
    //const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const productForm = document.getElementById(selector);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    //  Variant in Product Card
    var selector = `product-form-${this.dataset.section}`;
    var priceSelector = `price-${this.dataset.section}`;
    if (this.dataset.layout == 'card') {
      selector = `product-form-${this.dataset.section}-${this.dataset.product}`;
      priceSelector = `price-${this.dataset.section}-${this.dataset.product}`;
    }
    //const button = document.getElementById(`product-form-${this.dataset.section}`);
    const button = document.getElementById(selector);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    //const price = document.getElementById(`price-${this.dataset.section}`);
    const price = document.getElementById(priceSelector);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

// ===== Easify Swatch → Main Image Switcher =====
function initEasifySwitcher() {
  var easifyEl = document.querySelector('.easify-product-options');
  if (!easifyEl) return;

  var modifiedImg = null;     // the img element we replaced
  var originalSrc = null;     // its original src
  var originalSrcset = null;  // its original srcset
  var modifiedLink = null;    // the <a> wrapping the img (for lightbox href)
  var originalHref = null;    // original href of the <a>
  var savedSlideIndex = null; // slide index before Easify interaction

  function getSwatchImage(target) {
    if (target.classList.contains('tpo_image-swatch-img')) {
      return target.src.replace(/_\d+x\./i, '.');
    }
    var wrapper = target.closest('[class*="image-swatch"]');
    if (wrapper) {
      var img = wrapper.querySelector('.tpo_image-swatch-img');
      if (img && img.src) return img.src.replace(/_\d+x\./i, '.');
    }
    return null;
  }

  function getGalleryEl() {
    return document.querySelector('.gallery-main-left, .gallery-main-right, .gallery-main-center, .gallery-noslider');
  }

  function getActiveImg() {
    var galleryEl = getGalleryEl();
    if (!galleryEl) return null;
    var slide = galleryEl.querySelector('.swiper-slide-active');
    return slide ? slide.querySelector('img') : null;
  }

  function refreshZoom() {
    var activeSlide = document.querySelector('.swiper-slide-active .pdp-slider-img.zoom');
    if (!activeSlide || !window.$) return;
    // Remove old zoom image DOM first, then destroy events, then re-init
    $(activeSlide).find('.zoomImg').remove();
    $(activeSlide).trigger('zoom.destroy');
    $(activeSlide).zoom({
      url: false,
      callback: false,
      target: false,
      duration: 120,
      on: 'mouseover',
      touch: true,
      onZoomIn: false,
      onZoomOut: false,
      magnify: 2
    });
  }

  function restoreSlidePosition() {
    if (savedSlideIndex === null) return;
    var galleryEl = getGalleryEl();
    if (galleryEl && galleryEl.swiper) {
      galleryEl.swiper.slideTo(savedSlideIndex);
    }
    savedSlideIndex = null;
  }

  function restoreOriginal(restoreSlide) {
    if (modifiedImg && originalSrc) {
      modifiedImg.src = originalSrc;
      if (originalSrcset !== null) {
        modifiedImg.srcset = originalSrcset;
      }
    }
    if (modifiedLink && originalHref) {
      modifiedLink.href = originalHref;
    }
    modifiedImg = null;
    originalSrc = null;
    originalSrcset = null;
    modifiedLink = null;
    originalHref = null;
    if (restoreSlide === true) {
      restoreSlidePosition();
    }
  }

  function refreshAfterRestore() {
    // Small delay: wait for img src change to settle, then rebuild zoom
    setTimeout(function() { refreshZoom(); }, 100);
  }

  function swapToEasify(src) {
    // Clean up previous swap state without triggering zoom refresh yet
    if (modifiedImg && originalSrc) {
      modifiedImg.src = originalSrc;
      if (originalSrcset !== null) {
        modifiedImg.srcset = originalSrcset;
      }
    }
    if (modifiedLink && originalHref) {
      modifiedLink.href = originalHref;
    }
    modifiedImg = null;
    originalSrc = null;
    originalSrcset = null;
    modifiedLink = null;
    originalHref = null;
    savedSlideIndex = null;
    var img = getActiveImg();
    if (!img) return;
    modifiedImg = img;
    originalSrc = img.src;
    originalSrcset = img.srcset;
    // Also update the <a> link so lightbox opens the Easify image
    var link = img.closest('a');
    if (link) {
      modifiedLink = link;
      originalHref = link.href;
      link.href = src;
    }
    img.src = src;
    img.srcset = '';
    refreshAfterRestore();
  }

  // Easify swatch clicked → swap or restore
  // Use mousedown to capture state BEFORE Easify changes classes
  easifyEl.addEventListener('mousedown', function(e) {
    var newSrc = getSwatchImage(e.target);
    var checkedEl = e.target.closest('.tpo_is_checked_swatches, .tpo_checked');

    // Only handle clicks on actual option elements (not blank space between swatches)
    var optionEl = e.target.closest('[class*="tpo_"]');
    if (!optionEl) return;

    if (checkedEl) {
      // Clicking an already-selected swatch → will uncheck → restore
      var galleryEl = getGalleryEl();
      savedSlideIndex = galleryEl && galleryEl.swiper ? galleryEl.swiper.activeIndex : null;
      setTimeout(function() { restoreOriginal(true); refreshAfterRestore(); }, 50);
    } else if (newSrc) {
      // Clicking an unselected swatch → will check → swap
      setTimeout(function() { swapToEasify(newSrc); }, 50);
    } else {
      // Clicking non-image option (label/radio) → restore so gallery shows real variant image
      restoreOriginal(false);
      refreshAfterRestore();
    }
  });

  // Thumbnail clicked → restore original image
  (function bindSwiper() {
    var galleryEl = document.querySelector('.gallery-main-left, .gallery-main-right, .gallery-main-center, .gallery-noslider');
    if (galleryEl && galleryEl.swiper) {
      galleryEl.swiper.on('slideChangeTransitionStart', function() { restoreOriginal(); refreshAfterRestore(); });
      // Show default Easify image on load
      setTimeout(autoShowDefault, 500);
    } else {
      setTimeout(bindSwiper, 200);
    }
  })();

  function autoShowDefault() {
    var checked = easifyEl.querySelector('.tpo_is_checked_swatches, .tpo_checked');
    if (checked) {
      var img = checked.querySelector('.tpo_image-swatch-img');
      if (img && img.src) {
        swapToEasify(img.src.replace(/_\d+x\./i, '.'));
      }
    }
  }
}

// Easify loads late — poll until it appears
(function poll() {
  if (document.querySelector('.easify-product-options')) {
    initEasifySwitcher();
  } else {
    setTimeout(poll, 300);
  }
})();

// =============================================
// Notify Me When Available Modal
// =============================================
var _notifyModalReady = false;
var _notifyProductTitle = '';

function openNotifyModal(variantId) {
  _notifyProductTitle = ($('.pdp-right-column .section-title h1, .pdp-right-column .section-title h2').first().text().trim()) || document.title || 'Unknown product';
  if (!_notifyModalReady) {
    var html = '<div id="notify-modal-overlay" class="notify-modal-overlay">' +
      '<div class="notify-modal">' +
        '<button type="button" class="notify-modal-close" aria-label="Close">&times;</button>' +
        '<h3 class="notify-modal-title">Notify me when available</h3>' +
        '<p class="notify-modal-desc">Enter your email address and we\'ll let you know when this item is back in stock.</p>' +
        '<form id="notify-form" action="/contact" method="POST" target="notify-iframe" accept-charset="UTF-8">' +
        '<input type="hidden" name="form_type" value="contact" />' +
        '<input type="hidden" name="utf8" value="&#x2713;" />' +
        '<input type="hidden" name="contact[body]" id="notify-body" value="" />' +
        '<div class="notify-modal-field">' +
          '<label class="notify-modal-label" for="notify-email">Email address</label>' +
          '<div class="notify-modal-input-wrap">' +
            '<svg class="notify-modal-envelope" width="18" height="18" viewBox="0 0 16 16" fill="none"><rect x="1" y="3" width="14" height="10" rx="1" stroke="currentColor" stroke-width="1.2"/><path d="M1.5 3.5l6.5 5 6.5-5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>' +
            '<input type="email" id="notify-email" name="contact[email]" class="notify-modal-input" placeholder="Email address" required />' +
          '</div>' +
        '</div>' +
        '<div class="notify-modal-field">' +
          '<span class="notify-modal-label">Notify me for:</span>' +
          '<label class="notify-modal-radio"><input type="radio" name="notify-location" value="" checked /><span>Either location</span></label>' +
          '<label class="notify-modal-radio"><input type="radio" name="notify-location" value="auckland" /><span>Auckland</span></label>' +
          '<label class="notify-modal-radio"><input type="radio" name="notify-location" value="christchurch" /><span>Christchurch</span></label>' +
        '</div>' +
        '<button type="submit" class="notify-modal-submit" id="notify-submit">Notify me</button>' +
        '</form>' +
        '<p class="notify-modal-footer">We\'ll only use your email to send this stock notification.</p>' +
        '<iframe name="notify-iframe" style="display:none" id="notify-iframe"></iframe>' +
      '</div>' +
    '</div>';
    $('body').append(html);

    $('#notify-modal-overlay').on('click', function(e) {
      if (e.target === this) closeNotifyModal();
    });
    $('.notify-modal-close').on('click', closeNotifyModal);

    $('#notify-iframe').on('load', function() {
      closeNotifyModal();
      showNotifySuccess();
    });

    $('#notify-form').on('submit', function() {
      var loc = $('input[name="notify-location"]:checked').val() || '';
      var baseBody = $('#notify-body').val();
      $('#notify-body').val(baseBody + '\nLocation: ' + (loc || 'Either'));
    });

    _notifyModalReady = true;
  }

  $('#notify-email').val('');
  $('#notify-body').val('Back in stock request\nProduct: ' + _notifyProductTitle + '\nVariant ID: ' + variantId + '\nProduct URL: ' + window.location.href);
  $('input[name="notify-location"][value=""]').prop('checked', true);
  $('#notify-modal-overlay').data('variant-id', variantId).css('display','flex').hide().fadeIn(200);
  $('body').addClass('notify-modal-open');
  $('#notify-email').css('border-color', '#ddd');
}

function closeNotifyModal() {
  $('#notify-modal-overlay').fadeOut(200);
  $('body').removeClass('notify-modal-open');
}

function showNotifySuccess() {
  var $msg = $('#notify-success-toast');
  if (!$msg.length) {
    $msg = $('<div id="notify-success-toast" style="position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:#2a2a2a;color:#fff;padding:12px 24px;border-radius:8px;font-size:14px;z-index:999999;display:none;box-shadow:0 4px 16px rgba(0,0,0,0.15);">We\'ll notify you when this item is back in stock.</div>');
    $('body').append($msg);
  }
  $msg.fadeIn(300).delay(3000).fadeOut(300);
}

// Delegated handler for notify buttons
$(document).on('click', '.js-notify-btn', function(e) {
  e.preventDefault();
  openNotifyModal($(this).data('variant-id'));
});